module.exports = __webpack_public_path__ + "static/media/capa_placas.cb8575c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Placas/capa_placas.jpg
// module id = 350
// module chunks = 0